import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import {Box, Dialog, DialogActions, DialogContent} from '@material-ui/core';

import {withStyles} from '@material-ui/core/styles';
import TargetDntList from '../molecules/targetDntList';
import PositiveButton from '../../../../atoms/Buttons/PositiveButton';
import NegativeButton from '../../../../atoms/Buttons/NegativeButton';

const styles = (theme) => ({
  dialogLayout: {
    display: 'flex',
    flexDirection: 'column',
  },
  dialogContent: {
    minWidth: 0,
    display: 'flex',
    flexDirection: 'row',
  },
  dntSection: {
    flex: '0 0 auto',
    // 線路名等が長い場合に右側の入力エリアを圧迫しないよう最大幅を設け、超過分は横スクロールとする
    maxWidth: 280,
    minWidth: 0,
    marginRight: theme.spacing(2),
    position: 'sticky',
    top: 0,
  },
  mainSection: {
    flex: '1 1 auto',
    minWidth: 0,
  },
});

const BasePopup = (props) => {
  const {
    selectedDntList,
    dntListMaxHeight,
    disabled,
    readOnly,
    classes,
    children,
    onOk,
    onCancel,
    ...rest
  } = props;

  const onClose = (_e, reason) => {
    // ボタンクリック以外なにもしない
    if (reason !== 'buttonClick') {
      return;
    }
  };

  return (
    <Dialog
      {...rest}
      className={clsx(classes.dialogLayout)}
      onClose={onClose}
    >
      <DialogContent className={classes.dialogContent}>
        <TargetDntList
          className={classes.dntSection}
          dntList={selectedDntList}
          maxHeight={dntListMaxHeight}
        />

        <Box className={classes.mainSection}>
          {children}
        </Box>
      </DialogContent>

      <DialogActions>
        {!readOnly && (
          <PositiveButton
            disabled={disabled}
            size="small"
            style={{minWidth: 'unset', padding: '6px 16px'}}
            onClick={onOk}
            type="submit"
          >
            OK
          </PositiveButton>
        )}

        <NegativeButton
          size="small"
          style={{minWidth: 'unset', padding: '6px 16px'}}
          onClick={onCancel}
        >
          キャンセル
        </NegativeButton>
      </DialogActions>
    </Dialog>
  );
};

BasePopup.propTypes = {
  selectedDntList: PropTypes.array.isRequired,
  dntListMaxHeight: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default withStyles(styles)(BasePopup);
